<app-dtc-table-search
  (searchTriggered)="onSearchTriggered($event)"
  (downloadTriggered)="onDownloadTriggered()"
  [recyclingModeEnabled]="recyclingModeEnabled"
></app-dtc-table-search>
<div
  #scrollContainer
  class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-screen-200 min-h-screen-200 overflow-y-auto mt-2"
>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0">
      <tr>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Dtc'"
            [field]="getPropertyName('number')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('number'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Implementation Hint'"
            [field]="getPropertyName('implementationHint')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('implementationHint'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        @if (!recyclingModeEnabled) {
          <th scope="col" class="px-2 py-3">Assigned to EM</th>
        }
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Priority'"
            [field]="getPropertyName('priority')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('priority'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Tr. UT'"
            [field]="getPropertyName('translationStateTerminal')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('translationStateTerminal'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Tr. DOC'"
            [field]="getPropertyName('translationStateDocumentation')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('translationStateDocumentation'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'AS Review'"
            [field]="getPropertyName('reviewedByAfterSalesAt')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('reviewedByAfterSalesAt'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'TO Review'"
            [field]="getPropertyName('reviewedByTechnicalOrganisationAt')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('reviewedByTechnicalOrganisationAt'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <!-- HINT: Currently modified by might not be the user who deactivated the item -->
        <!-- @if (recyclingModeEnabled) {
          <th scope="col" class="px-6 py-3">
            <app-header-sorter
              [headerTitle]="'Deactivated By'"
              [field]="getPropertyName('modifiedBy')"
              [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('modifiedBy'))"
              (clicked)="sortBy($event)"
            ></app-header-sorter>
          </th>
        } -->
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Last Update'"
            [field]="getPropertyName('modifiedOn')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('modifiedOn'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (dtcs?.length === 0) {
        <tr>
          <td class="px-6 py-4 text-center font-medium text-amazone-orange whitespace-nowrap" colspan="12">
            No dtcs found
          </td>
        </tr>
      }
      @for (dtc of dtcs; track $index) {
        <tr
          (click)="onDtcClicked($safeNavigationMigration(dtc?.id))"
          [ngClass]="
            isSelected($safeNavigationMigration(dtc?.id))
              ? 'bg-orange-100 sticky top-14 bottom-0 text-amazone-orange translated-x-1 border-l-4 border-amazone-orange'
              : 'odd:bg-white even:bg-gray-50 hover:bg-gray-100 hover:text-amazone-orange border-b border-gray-200 '
          "
          class="transition-all duration-150"
        >
          <td class="px-6 py-4 font-semibold whitespace-nowrap cursor-pointer">
            {{ dtc?.displayId ?? 'N/A' }}
          </td>
          <td class="px-6 py-4 cursor-pointer">
            {{ commonUtils.truncateString(dtc?.implementationHint ?? 'N/A', 50) }}
          </td>
          @if (!recyclingModeEnabled) {
            <td class="px-6 py-4 cursor-pointer text-amazone-green whitespace-nowrap">
              @if (dtc?.errorMessageId) {
                <a (click)="navigateToErrorMessage(dtc.errorMessage)" class="cursor-pointer">
                  <span class="font-bold me-2">{{ dtc?.errorMessage?.code }}</span>
                  {{ dtc?.errorMessage?.headerOnTerminal }}
                </a>
              } @else {
                -
              }
            </td>
          }
          <td class="px-6 py-4 cursor-pointer">
            {{ dtc?.priority ?? 'N/A' }}
          </td>
          <td class="px-6 py-4 cursor-pointer">
            <span
              class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full"
              [ngClass]="commonUtils.translationStateToColor($safeNavigationMigration(dtc?.translationStateTerminal))"
              title="{{
                commonUtils.friendlyTranslationState($safeNavigationMigration(dtc?.translationStateTerminal))
              }}"
            >
            </span>
          </td>
          <td class="px-6 py-4 cursor-pointer">
            <span
              class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full"
              [ngClass]="
                commonUtils.translationStateToColor($safeNavigationMigration(dtc?.translationStateDocumentation))
              "
              title="{{
                commonUtils.friendlyTranslationState($safeNavigationMigration(dtc?.translationStateDocumentation))
              }}"
            >
            </span>
          </td>
          <td class="px-6 py-4 cursor-pointer whitespace-nowrap">
            {{ $safeNavigationMigration(dtc?.reviewedByAfterSalesAt) | date: 'yyyy.MM.dd HH:mm' }}
          </td>
          <td class="px-6 py-4 cursor-pointer whitespace-nowrap">
            {{ $safeNavigationMigration(dtc?.reviewedByTechnicalOrganisationAt) | date: 'yyyy.MM.dd HH:mm' }}
          </td>
          <!-- @if (recyclingModeEnabled) {
            <td class="px-6 py-4 cursor-pointer">
              {{ dtc?.modifiedBy ?? 'N/A' }}
            </td>
          } -->
          <td
            class="px-6 py-4 cursor-pointer whitespace-nowrap"
            [ngClass]="{ 'font-semibold': commonUtils.isToday($safeNavigationMigration(dtc?.modifiedOn)) }"
          >
            {{ $safeNavigationMigration(dtc?.modifiedOn) | date: 'yyyy.MM.dd HH:mm' }}
          </td>
          <td class="px-6 py-4">
            <div class="w-5 grid grid-cols-2 gap-10">
              @if (recyclingModeEnabled) {
                <button
                  [appEnabledByPolicy]="[policy.canDeleteHard, hardDeleteDisabled]"
                  (click)="
                    showDecisionModal(dtc.id, dtc.displayId); deleteDecisionModal.openModal(); $event.stopPropagation()
                  "
                  type="button"
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="hardDeleteDisabled"
                  appAgentAction
                  [agent]="'dtc-hard-delete-' + dtc.id"
                  businessObject="dtc"
                  [businessId]="dtc.id"
                  action="delete"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
                <button
                  [appEnabledByPolicy]="[policy.canRestore, restoreDisabled]"
                  (click)="restoreDtc(dtc); $event.stopPropagation()"
                  type="button"
                  class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="restoreDisabled"
                  appAgentAction
                  [agent]="'dtc-restore-' + dtc.id"
                  businessObject="dtc"
                  [businessId]="dtc.id"
                  action="restore"
                >
                  <app-restore-icon></app-restore-icon>
                </button>
              } @else {
                <button
                  type="button"
                  [appEnabledByPolicy]="[policy.canDeleteSoft, softDeleteDisabled]"
                  (click)="
                    showDecisionModal($safeNavigationMigration(dtc?.id), $safeNavigationMigration(dtc?.displayId));
                    softDeleteDecisionModal.openModal();
                    $event.stopPropagation()
                  "
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  appAgentAction
                  [agent]="'dtc-deactivate-' + dtc.id"
                  businessObject="dtc"
                  [businessId]="dtc.id"
                  action="deactivate"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
              }
              @if (dtc?.internalNotes) {
                <app-note-icon class="text-orange-300"></app-note-icon>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<app-decision-modal
  #softDeleteDecisionModal
  (decision)="onSoftDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(dtcToRemove?.id)"
  [entityName]="$safeNavigationMigration(dtcToRemove?.displayId)"
  [businessObject]="'dtc'"
  [header]="'Deactivation of'"
  [details]="[
    'This DTC will not be permanently deleted, but only deactivated. Additionally, all links to the error messages will be removed. Do you want to proceed?',
  ]"
></app-decision-modal>
<app-decision-modal
  #deleteDecisionModal
  (decision)="onHardDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(dtcToRemove?.id)"
  [entityName]="$safeNavigationMigration(dtcToRemove?.displayId)"
  [businessObject]="'dtc'"
  [header]="'Deletion of'"
  [details]="['This DTC will be permanently deleted. Do you want to proceed?']"
></app-decision-modal>
